import React from "react";
import { Col, Figure, Form, Row } from "react-bootstrap";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { whiteSpaceCheck } from "../../helper/helper";
import { ErrorMessage } from "@hookform/error-message";
import { MaxLength } from "../../utils/constants/CharactersLength";
import PhoneInputField from "../../components/shared/FormFields/PhoneInputField";
import { regex } from "../../utils/constants/regexVariables";
import ODatePicker from "../../components/shared/datePicker/ODatePicker";
import CropImageModal from "../shared/modal/CropImageModal";
import useToastContext from "../../hooks/useToastContext";

const MainMemberInfo = ({
  register,
  errors,
  setValue,
  setPhone,
  phone,
  dob,
  handleChangeDate,
  dateError,
  setProfilePic,
  profilePic,
  // handleProfileUpload,
  setShowCropModal,
  showCropModal,
  setImageToCrop,
  imageToCrop,
  setProfileFile,
}) => {
  const notification = useToastContext();

  const handleProfileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ["image/png", "image/jpg", "image/jpeg"];
      if (!allowedTypes.includes(file.type)) {
        notification.error(
          "Please upload an image in PNG,JPEGSSS or JPG format."
        );
        return;
      }

      if (file.size > 300 * 1024) {
        notification.error("Please upload an image smaller than 200 KB.");
        return;
      }

      const blobURL = URL.createObjectURL(file);
      setImageToCrop(blobURL);
      setShowCropModal(true);
      setProfileFile(file);
    }
  };

  const saveCroppedImage = (croppedAreaPixels) => {
    if (!croppedAreaPixels || !imageToCrop) return;

    const image = new Image();
    image.src = imageToCrop;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      ctx.drawImage(
        image,
        croppedAreaPixels.x,
        croppedAreaPixels.y,
        croppedAreaPixels.width,
        croppedAreaPixels.height,
        0,
        0,
        croppedAreaPixels.width,
        croppedAreaPixels.height
      );

      // Generate a dynamic filename with timestamp
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      var dynamicFileName = `cropped-image-${timestamp}.png`;
      dynamicFileName.replace("-", "_");

      canvas.toBlob((blob) => {
        const croppedFile = new File([blob], dynamicFileName, {
          type: "image/png",
        });
        setProfilePic(URL.createObjectURL(croppedFile)); // Update the profile picture
        setProfileFile(croppedFile); // Save the cropped file
      }, "image/png");
    };
  };
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Main Member Information</span>
      <Row className="mb-3 gx-sm-3 gx-2">
        {/* <Col md={12} className="mb-md-4 mb-2">
          <div className="profile-container">
            <Figure className="profile-figure">
              <Figure.Image
                src={profilePic}
                alt="No_Image"
                className="profile-image"
              />
              <span className="camera-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="camera-svg"
                >
                  <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                  <circle cx="12" cy="13" r="3"></circle>
                </svg>
              </span>
              <input
                type="file"
                accept="image/*"
                className="profile-file-input"
                onChange={handleProfileUpload}
              />
            </Figure>
          </div>
        </Col> */}

        <Col md={12} className="mb-md-4 mb-2">
          <div className="profile-container">
            <Figure className="profile-figure">
              <Figure.Image
                src={profilePic}
                alt="Profile"
                className="profile-image"
              />
              <span className="camera-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="camera-svg"
                >
                  <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                  <circle cx="12" cy="13" r="3"></circle>
                </svg>
              </span>
              <input
                type="file"
                accept="image/*"
                className="profile-file-input"
                onChange={handleProfileUpload}
              />
            </Figure>
          </div>

          {/* Crop Image Modal */}
          {showCropModal && (
            <CropImageModal
              show={showCropModal}
              handleClose={() => setShowCropModal(false)}
              imageSrc={imageToCrop}
              saveCroppedImage={saveCroppedImage}
            />
          )}
        </Col>
        <Col xl={3} md={4} xs={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label>
              Main member name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="First name"
              name="firstName"
              {...register("firstName", {
                required: ValidationMessage.FIRST_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
              maxLength={MaxLength.nameLen}
            />
            <ErrorMessage
              errors={errors}
              name="firstName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} xs={6} className="mb-3">
          <Form.Group controlId="formGivenName">
            <Form.Label className="">&nbsp;</Form.Label>
            <Form.Control
              type="text"
              placeholder="Last name"
              name="lastName"
              {...register("lastName", {
                required: ValidationMessage?.LAST_NAME_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
              maxLength={MaxLength.nameLen}
            />
            <ErrorMessage
              errors={errors}
              name="lastName"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formCountryCode">
            <Form.Label>
              Main member mobile number <span className="text-danger">*</span>
            </Form.Label>
            <PhoneInputField
              register={register}
              setValue={setValue}
              errors={errors}
              name="mobile"
              validationMessage={ValidationMessage}
              regex={regex}
              countryCode="+91"
              initialPhone=""
              setPhone={setPhone}
              phone={phone}
              className={""}
            />
          </Form.Group>
          <ErrorMessage
            errors={errors}
            name="mobile"
            render={({ message }) => (
              <p className="error-message text-start py-2 px-1 text-danger">
                {message}
              </p>
            )}
          />
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label>
              Main member e-mail <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Email"
              name="email"
              {...register("email", {
                required: ValidationMessage.EMAIL_REQUIRED,
                pattern: {
                  value: regex.regEmail,
                  message: ValidationMessage.ENTER_VALID_EMAIL,
                },
              })}
            />

            <ErrorMessage
              errors={errors}
              name="email"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formYearOfBirth">
            <Form.Label>
              Date of birth <span className="text-danger">*</span>
            </Form.Label>

            <ODatePicker
              name="expiryDate"
              value={dob && new Date(dob)}
              placeholder={"your date of birth"}
              errors={errors}
              onChange={handleChangeDate}
              dateError={dateError}
              className="form-control"
              maxDate={new Date()}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formNativePlace">
            <Form.Label>Place of birth</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your native place"
              name="placeOfBirth"
              {...register("placeOfBirth", {
                required: false,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label>Type of brahman</Form.Label>
            <Form.Control
              type="text"
              placeholder="Which brahman you are"
              name="religion"
              {...register("religion", {
                required: false,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label>Gotra</Form.Label>
            <Form.Control
              type="text"
              placeholder="Your gotra type"
              name="gotra"
              {...register("gotra", {
                required: false,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label>Gender</Form.Label>
            <Form.Select
              name="gender"
              {...register("gender", {
                required: ValidationMessage?.GENDER_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            >
              <option value="">Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              {/* <option value="other">Other</option> */}
            </Form.Select>

            <ErrorMessage
              errors={errors}
              name="gender"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label>Belong from</Form.Label>
            <Form.Control
              type="text"
              placeholder="your native place"
              name="villageName"
              {...register("villageName", {
                required: false,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label>Reference Person</Form.Label>
            <Form.Control
              type="text"
              placeholder="Must be an existing member of the Samaj"
              name="referencePerson"
              {...register("referencePerson", {
                required: false,
                validate: (value) => whiteSpaceCheck(value),
              })}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default MainMemberInfo;
